let properties = {

    getErrorMessage(message) {

        // if (message.includes("exceeded.maxcourses.degree"))
        //     return "Δεν βρέθηκε εγγραφή. Πατήστε ανανέωση και αν το πρόβλημα επιμείνει επικοινωνήστε με το Γραφείο αρωγής χρηστών";

        //-----------
       if (message.includes("student.not.active"))
            return "Ο λογαριασμός σας δεν είναι ενεργός. Παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών";

        //-----------
        else if (message.includes("{error}"))
            return message.split('}')[1];

        //-----------
        else if (message.includes("student.has.not.accepted.terms"))
            return " Δεν έχετε αποδεχτεί τους όρους και προϋποθέσεις για υποβολή δήλωσης";

       //-----------
       else if (message.includes("course.registration.api.error"))
           return "Δεν εντοπίστηκε εγγεγραμμένος φοιτητής/τρια με το ΑΜ σας, παρακαλούμε όπως επικοινωνήσετε με το Γραφείο Μηχανοργάνωσης του ιδρύματός σας";

        //-----------
        else if (message.includes("student.already.has.statement"))
            return "Υπάρχει προηγούμενη δήλωση για την ίδια περίοδο. Παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών.";

        //----------
        else if (message.includes("student.has.wrongly.delivered.books"))
            return "Ο παραλαμβάνων φοιτητής έχει βιβλία που είναι μαρκαρισμένα ως εσφαλμένες παραδόσεις. Δεν μπορείτε να ολοκληρώσετε την ανταλλαγή, παρακαλώ επικονωνήστε με το Γραφείο Αρωγής χρηστών.";

        //----------
        else if (message.includes("exceeded.maxcourses.period"))
            return "Η δήλωση δεν μπορεί να αποθηκευτεί: Έχετε ξεπεράσει το μέγιστο όριο μαθημάτων για τα οποία δικαιούστε συγγράμματα για την συγκεκριμένη περίοδο. Εάν υπάρχει πρόβλημα, παρακαλούμε να επικοινωνήσετε με το Γραφείο Αρωγής Χρηστών.";

        //----------
        else if (message.includes("exceeded.maxcourses.degree"))
            return "Η δήλωση δεν μπορεί να αποθηκευτεί: Έχετε ξεπεράσει το μέγιστο συνολικό όριο μαθημάτων για τα οποία δικαιούστε συγγράμματα για τη φοίτηση στη σχολή σας.";

        //----------
        else if (message.includes("bookgroup.not.in.active.year"))
            return "bookgroup.not.in.active.year";

        //----------
        else if (message.includes("one.bookgroup.per.course"))
            return "Έχουν επιλέγει περισσότερες ομάδες συγγραμμάτων για το ίδιο μάθημα. Παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών.";

        //----------
        else if (message.includes("exchange.credits.exceeded"))
            return "Οι επιλογές σας ξεπερνάνε τις μονάδες που έχετε από ανταλλαγή. Παρακαλώ μειώστε το πλήθος των επιλογών για να συνεχίσετε.";

        //----------
        else if (message.includes("not.authorized"))
            return 'Έχετε αποσυνδεθεί προσωρινά. Για να επανασυνδεθείτε παρακαλούμε πατήστε εδώ <a href="http://service.eudoxus.gr/student">http://service.eudoxus.gr/student/</a> Εαν επιθυμείτε να αποσυνδεθείτε θα πρέπει να κλείσετε τον περιηγητή σας.';

        //----------
        else if (message.includes("no.policy.accepted"))
            return "no.policy.accepted";

        //----------
        else if (message.includes("no.active.courses.period"))
            return "Το τμήμα δεν επιτρέπει αυτή τη στιγμή δηλώσεις συγγραμμάτων. Παρακαλώ δοκιμάστε αργότερα.";
        //
        // //----------
        else if (message.includes("exceeded.max.course.semester"))
            return "Η δήλωση δεν μπορεί να αποθηκευτεί: Έχετε επιλέξει μάθημα απο εξάμηνο που δεν δικαιούστε.";

       else if (message.includes("exchange.destination.book.wrong.pin"))
           return "Λάθος κωδικός ανταλλαγής, δεν βρέθηκε ή δεν ανήκει στον φοιτητή που έχει επιλέξει το βιβλίο.";

       else if (message.includes("exchange.source.book.delivered.in.current.period"))
           return "Δεν μπορείτε να δηλώσετε για ανταλλαγή συγγράμματα τα οποία παραλάβατε στην τρέχουσα περίοδο. Τα συγγράμματα αυτά θα μπορείτε να τα διαθέσετε για ανταλλαγή από το επόμενο εξάμηνο.";

       else if (message.includes("exchange.expired.date"))
           return "Δεν μπορείτε να παραλάβετε βιβλία μέσω ανταλλαγής καθώς έχει παρέλθει η σχετική προθεσμία";

       else if (message.includes("not.able.toremove.group.with.exchanging.books"))
           return "Δεν επιτρέπεται να αφαιρεθεί ομάδα συγγραμμάτων που περιέχει βιβλία για τα οποία έχει ξεκινήσει η διαδικασία ανταλλαγής με άλλον φοιτητή.";

       else if (message.includes("student.book.not.published"))
           return " Το βιβλίο δεν είναι επιλέξιμο (είναι ηλεκτρονικό σύγγραμμα ή δωρεάν σημειώσεις;).";

       else if (message.includes("student.book.already.exists"))
           return "Το βιβλίο υπάρχει ήδη στη λίστα βιβλίων ή σε κάποια δήλωση συγγραμμάτων σας.";

       else if (message.includes("inactive.bookgroup.added"))
           return "Μια απο τις επιλογές συγγραμμάτων της δήλωσής σας έχει απενεργοποιηθεί από τη γραμματεία σας. Παρακαλώ πατήστε \"Ανανέωση\" στον περιηγητή σας και ξαναφτιάξτε τη δήλωσή σας.";

       else if (message.includes("exchange.source.book.not.delivered"))
           return "Ο διαθέτης δεν έχει στην κατοχή του το βιβλίο.";

       else if (message.includes("exchange.source.book.already.selected"))
           return "Το βιβλίο έχει ήδη επιλεγεί από φοιτητή για ανταλλαγή. Δεν επιτρέπεται η ενέργεια. Πατήστε ανανέωση.";

       //
        // //----------
        // else if (message.includes("exchange.src.exists"))
        //     return "Έχει ενεργοποιηθεί η διαδικασία παραλαβής από φοιτητή. Δεν μπορείτε να παραλάβετε το βιβλίο από το Σ.Δ.";
        //
        // //----------
        // else if (message.includes("has no availability for"))
        //     return "Δεν είναι δυνατή η παράδοση του βιβλίου καθώς δεν υπάρχει διαθεσιμότητα για το βιβλίο που επιλέξατε.";
        //
        // //----------
        // else if (message.includes("student.has.wrongly.delivered.books"))
        //     return "Έχετε εκρεμμότητες βιβλίων που έχετε παραλάβει εσφαλμένα στην προηγούμενη δήλωσή σας. Δεν μπορείτε να κάνετε υποβολή δήλωσης ή να παραλάβετε βιβλία μέχρι να διευθετήσετε τις εκκρεμότητες αυτές.";
        //
        // //----------
        else if (message.includes("no active period"))
            return "Το τμήμα δεν επιτρέπει αυτή τη στιγμή δηλώσεις συγγραμμάτων. Παρακαλώ δοκιμάστε αργότερα.";
        //
        // //-----------
        else
            return "Παρουσιάστηκε κάποιο σφάλμα στην επικοινωνία με το σύστημα. Πατήστε \"Ανανέωση\" στον browser και αν το πρόβλημα επιμείνει παρακαλώ επικοινωνήστε με το Γραφείο Αρωγής Χρηστών";
    }
};

export default properties